<template>
  <div class="download-box">
    <div class="downloadbox assetlist layout-1-col">
        <ul>
          <li v-for="file in files" :key="file.id">
              <div>
                  <a class="more-black" @click.stop="onDownload(file.url)">
                      {{file.name}} ({{file.size}})
                  </a>
              </div>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import Labels from "../services/labels.js";

export default {
  name: "DownloadBox",
  props: ["files"],
  components: {
    
  },
  data() {
    return {
      labels: Labels
    };
  },
  methods: {
    onDownload(url) {
      window.open(url, "_self");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downloadbox.assetlist > UL {
  float: none;
  width: 100%;
}
.downloadbox > UL > Li:first-of-type {
  border-top: none;
}

.downloadbox > UL > Li:last-of-type {
  border-bottom: none;
}
</style>
